import React from "react";

interface SpecializedPageHeaderProps {
  hasHeaderData: boolean;
  hasBackground: boolean;
  pageName: string;
  subtitle: string;
  couponCode: string;
  dealMessage: string;
  backgroundImage: string;
}

const SpecializedPageHeader = ({
  hasHeaderData,
  hasBackground,
  pageName,
  subtitle,
  couponCode,
  dealMessage,
  backgroundImage,
}: SpecializedPageHeaderProps) => {
  return (
    <>
      {hasHeaderData ? (
        <div
          style={{
            backgroundImage: "linear-gradient(to bottom, #234858, #4e6c7a)",
          }}
          className={`bg-gradient-to-b from-dark-blue-300 to-light-blue-200 h-auto ${
            hasBackground ? "mb-10 lt:mb-8" : "mb-0 lt:mb-0"
          } max-h-50 overflow-hidden relative text-center lt:-mt-6`}
        >
          <div className="container pt-12 pb-12 relative inset-0 text-left lt:flex lt:items-center z-[1]">
            <div className="box-border flex flex-wrap justify-between text-left antialiased w-full xs:py-10 lt:items-center lt:py-10">
              <div className="inline-block max-w-full w-full lt:flex-grow lt:w-26">
                {pageName && (
                  <h1
                    style={{ textShadow: "rgba(0, 0, 0, 0.5) 0px 2px 3px" }}
                    className="block text-4xl leading-9 mb-1 text-left text-white md:text-5xl md:mb-3 lt:mb-0"
                  >
                    {pageName}
                  </h1>
                )}
                {subtitle && (
                  <h2
                    style={{ textShadow: "rgba(0, 0, 0, 0.5) 0px 2px 3px" }}
                    className="subtitle block font-normal text-lg leading-5 mb-1 text-left text-white lt:mt-2"
                  >
                    {subtitle}
                  </h2>
                )}
              </div>
              {couponCode && (
                <div className="text-sm mt-3 max-w-xs text-left text-white uppercase w-full lt:self-center lt:flex-grow lt:float-right lt:text-base lt:mt-0 lt:text-right lt:w-24">
                  <div className="inline-block text-center">
                    <div
                      data-testid="coupon-code"
                      className="coupon-code bg-white inline-block min-w-35 py-1 px-3 text-black xs:py-4 xs:px-5"
                    >
                      {"Use Code: "}
                      <b>{couponCode}</b>
                    </div>
                    <div
                      data-testid="coupon-valid"
                      className="coupon-valid text-2xs normal-case lt:text-sm-1/2"
                    >
                      {dealMessage}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            data-testid="hero-img"
            className="hero-img hidden my-0 mx-auto absolute inset-0 w-full lt:block"
            style={{
              backgroundImage: `url("${backgroundImage}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top center",
              backgroundSize: "cover",
            }}
          />
        </div>
      ) : (
        <div className="page-header-container flex items-center">
          <div className="flex-1">
            <h1 className="page-header">{pageName}</h1>
            <h2 className="page-header2">{subtitle}</h2>
          </div>
        </div>
      )}
    </>
  );
};

export default SpecializedPageHeader;
